module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('a', {
    staticClass: "weui-cell weui-cell_link",
    attrs: {
      "href": _vm.link,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onItemClick
    }
  }, [_c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._t("default")], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-1685baa9!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/cells/cells-link.vue
// module id = 222
// module chunks = 0